import * as React from "react";
import { User } from "lucide-react";
import { cn } from "@/lib/cn";

const SIZE_MAP = {
  24: "size-6 text-caption",
  32: "size-8 text-body-sm",
  40: "size-10 text-body-sm",
  48: "size-12 text-body",
  64: "size-16 text-h6",
  96: "size-24 text-h4",
} as const;

export interface AvatarProps extends React.HTMLAttributes<HTMLSpanElement> {
  size?: keyof typeof SIZE_MAP;
  src?: string;
  name?: string;
}

/**
 * Avatar — Volume 03 §9. Fallback: ảnh → chữ cái đầu → icon.
 * Avatar học sinh không bắt buộc ảnh thật (bảo vệ riêng tư).
 */
export function Avatar({ size = 40, src, name, className, ...props }: AvatarProps) {
  const initials = name
    ? name
        .trim()
        .split(/\s+/)
        .slice(-2)
        .map((w) => w[0])
        .join("")
        .toUpperCase()
    : "";

  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-subtle font-medium text-foreground-secondary",
        SIZE_MAP[size],
        className
      )}
      {...props}
    >
      {src ? (
        // eslint-disable-next-line @next/next/no-img-element
        <img src={src} alt={name ?? ""} className="size-full object-cover" />
      ) : initials ? (
        <span aria-hidden="true">{initials}</span>
      ) : (
        <User className="size-1/2" aria-hidden="true" />
      )}
      {name && !src && <span className="sr-only">{name}</span>}
    </span>
  );
}
